export default __webpack_public_path__ + "static/media/circular_button.882894ab.png";